import { notification } from "antd";

type NotificationType = "success" | "error" | "warning" | "info";

export const notify = {
  success(message?: string, description?: string) {
    notification.success({
      message,
      description,
      showProgress: true,
      placement: "topRight",
    });
  },
  warning(message?: string, description?: string) {
    notification.warning({
      message,
      description,
      showProgress: true,
      placement: "topRight",
    });
  },
  info(message?: string, description?: string) {
    notification.info({
      message,
      description,
      showProgress: true,
      placement: "topRight",
    });
  },
  error(message?: string, description?: string) {
    notification.error({
      message,
      description,
      showProgress: true,
      placement: "topRight",
    });
  },
  toast(
    message?: string,
    variant: NotificationType = "info",
    description?: string
  ) {
    notification[variant]({
      message,
      description,
      showProgress: true,
      placement: "topRight",
    });
  },
};
